import { useState, useEffect } from 'react'
import { isInIframe } from '../services/iframe/iframeHelper'
import { getQueryParameter } from '../services/location/getQueryParameter'
import { parseBoolean } from '../services/environment/parseBoolean'

export const shouldHideCloseButton = (): boolean => {
  const canCloseQueryParameter = getQueryParameter('canClose')
  if (canCloseQueryParameter === undefined || canCloseQueryParameter === null) return !isInIframe()
  return !parseBoolean(canCloseQueryParameter)
}

/**
 * Evaluate during runtime on the client-side instead of build time on the server
 * */
function useHideCloseButton(): boolean {
  const [isHidden, setIsHidden] = useState(shouldHideCloseButton())

  useEffect(() => {
    setIsHidden(shouldHideCloseButton())
  })

  return isHidden
}

export default useHideCloseButton
